import VChart from 'vue-echarts';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { LineChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';

use([LineChart, GridComponent, CanvasRenderer, TooltipComponent]);

const optionColors = [
  ['204, 128, 61', '250, 177, 50'],
  ['80, 17, 182', '178, 71, 255'],
  ['219, 35, 101', '250, 103, 108'],
  ['101, 229, 46', '0, 128, 51'],
  ['75, 174, 250', '75, 174, 250'],
  ['0, 102, 102', '0, 102, 102'],
];

export default {
  name: 'componentsLine',

  props: {
    colors: {
      type: Array,
    },
    chartData: {
      type: Object,
    },
    flag: {
      type: Boolean,
    },
  },
  watch: {
    flag() {
      this.datainit();
      this.timerfn();
    },
  },
  components: {
    VChart,
  },

  data() {
    return {
      option: {
        tooltip: {
          trigger: 'axis',
          padding: 0,
          borderWidth: 0,
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: `rgba(${optionColors[this.colors[0]][0]}, 0)`,
                  },
                  {
                    offset: 1,
                    color: `rgba(${optionColors[this.colors[0]][1]}, 1)`,
                  },
                ],
              },
            },
          },
          backgroundColor: 'none',
          formatter(param) {
            console.log("param===", param);
            const { name, unit } = param[0];
            let str = '';
            param.forEach((item, index) => {
              console.log("item===111", item);
              const { value, seriesName } = item;
              str += `<span style="width:200px">${
                seriesName ? `${seriesName}：` : ""
              }</span><span class="arial" style="color:#ffb433;font-weight: bold;">${value}</span>`;
              if (index !== (param.length - 1)) {
                str += '<br />';
              }
            });
            return `<div class="white text-center" style="font-size: 12px;line-height:1.2;">
              <div><span class="arial">${name}</span></div>
              <div>${str}</div>
            </div>`;
          },
        },
        grid: {
          top: '15%',
          left: '5%',
          right: '5%',
          bottom: 0,
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: '#747375',
              fontSize: 10,
              fontFamily: 'Century Gothic',
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#ddd',
                opacity: 0.1,
              },
            },
            boundaryGap: false,
          },
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              color: '#747375',
              margin: 13,
              fontSize: 10,
              fontFamily: 'Century Gothic',
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [],
      },
    };
  },

  created() {
    this.datainit();
  },

  mounted() {
    setInterval(() => {
      this.timerfn();
    }, 8000);
  },
  methods: {
    timerfn() {
      const { $refs, option } = this;
      const { line } = $refs;
      if (!line) {
        return;
      }
      line.clear();
      line.setOption(option);
    },
    datainit() {
      const { option, colors, chartData } = this;
      const { category, series } = chartData;
      option.xAxis[0].data = category;
      const seriesFormat = [];
      let arr = series.filter(item => { return item.show });
      arr.forEach((item, index) => {
        const obj = {
          type: 'line',
          data: [],
          smooth: true,
          emphasis: {
            lineStyle: {
              width: 3,
            },
            itemStyle: {
              color: '#db2365',
              shadowBlur: 3,
              borderColor: '#fff',
              borderWidth: 2,
              shadowColor: 'rgba(0, 0, 0, 0.35)',
            },
          },
          lineStyle: {
            normal: {
              width: 3,
              color: {
                type: 'linear',
                colorStops: [
                  {
                    offset: 0,
                    color: '#db2365',
                  },
                  {
                    offset: 1,
                    color: '#fa676c',
                  },
                ],
              },
              cap: 'round',
              shadowBlur: 5,
              shadowColor: '#db2365',
              shadowOffsetY: 3,
            },
          },
          itemStyle: {
            color: '#db2365',
            shadowBlur: 3,
            borderColor: '#fff',
            borderWidth: 2,
            shadowColor: 'rgba(0, 0, 0, 0.35)',
          },
          showSymbol: false,
          symbolSize: 7,
        };
        obj.name = item.name;
        obj.data = item.value;
        obj.unit = item.unit;
        obj.itemStyle.color = `rgb(${optionColors[colors[item.colors]][0]})`;
        obj.emphasis.itemStyle.color = `rgb(${optionColors[colors[item.colors]][0]})`;
        obj.lineStyle.normal.shadowColor = `rgb(${optionColors[colors[item.colors]][0]})`;
        obj.lineStyle.normal.color.colorStops = [
          {
            offset: 0,
            color: `rgb(${optionColors[colors[item.colors]][0]})`,
          },
          {
            offset: 1,
            color: `rgb(${optionColors[colors[item.colors]][1]})`,
          },
        ];
        seriesFormat.push(obj);
      });
      option.series = seriesFormat;
    },
  },
};
